import { z } from 'zod';

// ---------------------------------------------------------------------------
// Zod validation schema
// ---------------------------------------------------------------------------
export const taskSchema = z
  .object({
    title: z.string().trim().min(4, 'Title is required'),
    type: z.string().trim().min(4, 'Task type is required'),
    projectName: z
      .object({
        id: z.any(),
        name: z.string().trim().min(1, 'Project is required')
      })
      .nullable()
      .refine((val) => val !== null, {
        message: 'Project is required'
      }),
    class: z
      .object({
        id: z.any(),
        name: z.string().trim().min(1)
      })
      .nullable()
      .optional(),
    assignedTo: z.any().optional(),
    dueDate: z.string().min(1),
    priority: z.string().min(3, 'Priority is required'),
    status: z.string().min(3, 'Status is required'),
    description: z.string().trim().min(4, 'Description is required'),

    location: z.string().optional(),
    estimatedHours: z.string().optional(),
    supportingStaff: z
      .array(
        z.discriminatedUnion('recipientType', [
          z.object({
            value: z.string().min(1),
            label: z.string().min(1),
            recipientType: z.literal('employee'),
            employeeId: z.any().refine(Boolean, 'Employee is required')
          }),
          z.object({
            value: z.string().min(1),
            label: z.string().min(1),
            recipientType: z.literal('external'),
            email: z.string().email('Enter a valid email address'),
            contactId: z.any().optional()
          })
        ])
      )
      .optional(),
    dependencies: z.array(z.any()).optional(),
    criticalReason: z.string().optional(),
    pendingReason: z.string().optional(),
    pendingComment: z.string().optional(),
    startTime: z
      .string()
      .regex(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/, { message: 'Invalid time format. Expected HH:MM' })
      .optional()
      .or(z.literal(''))
      .nullable()
  })
  .superRefine((data, ctx) => {
    if (data.status === 'Assigned' && !data.assignedTo) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['assignedTo'],
        message: 'Assigned To is required'
      });
    }
    if (data.status === 'Draft' && data.assignedTo) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['assignedTo'],
        message: 'Remove the assignee or change the status to Assigned'
      });
    }
  });
